import React from 'react';
import { ReactSVG } from 'react-svg';

// [prop]name
// - 제플린 상에서 확인되는 아이콘 이름과 동일하게 작성하면 됩니다.('icon'은 제외)
// - 예시: 제플린 Icon/Light/Basic/Cancellation -> light-basic-cancellation
// - svg 파일은 public/icons 내부의 svg 파일을 참조합니다.

// [prop]size
// - px 단위입니다.

// fallback
// - svg 파일 불러오기 등에서 오류 발생시 "Err"을 표시합니다.

const index = ({
  name,
  size = 24,
  onClick = () => {},
  disabled = false,
  ...props
}) => {
  return (
    <ReactSVG
      src={`/icons/icon-${name}.svg`}
      beforeInjection={(svg) => {
        svg.setAttribute('width', size);
        svg.setAttribute('height', size);
        !disabled && svg.setAttribute('style', 'cursor: pointer');
      }}
      onClick={onClick && onClick}
      loading={() => <svg style={{ width: size, height: size }}></svg>}
      fallback={() => (
        <div
          style={{
            color: 'var(--color-red)',
            border: '1px solid var(--color-red)',
            width: size,
            height: size,
          }}
        >
          Err
        </div>
      )}
      {...props}
    />
  );
};

export default index;
